var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-page',{staticClass:"cookie-policy",attrs:{"pagedata":this.pageData,"bannerimg":"/img/banner-policy.jpg"}},[(_vm.pageData.attributes.body!=undefined)?_c('div',{staticClass:"container-beige intro container",domProps:{"innerHTML":_vm._s(this.pageData.attributes.body.processed)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }